import { render, staticRenderFns } from "./hnr-textarea.vue?vue&type=template&id=0e008082&"
import script from "./hnr-textarea.vue?vue&type=script&lang=js&"
export * from "./hnr-textarea.vue?vue&type=script&lang=js&"
import style0 from "./hnr-textarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VContainer,VTextarea})
